// extracted by mini-css-extract-plugin
export default {"iconWrapper":"styles_iconWrapper__aF8N8","successMsg":"styles_successMsg__tXahV"};